export default "__VITE_ASSET__0275844a__"